import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import ChannelService from "../../library/ChannelService";

const EventStoryDetailContainer = (props) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [state, setState] = useState({});

  useEffect(() => {
    ChannelService.shutdown();
  }, []);

  return (
    <>
      <div style={{
        backgroundColor: "#FFF3D6",
      }}>
        <div style={{
          maxWidth: "500px",
          margin: "auto",
        }}>
          <img
            width={"100%"}
            src={"https://firebasestorage.googleapis.com/v0/b/readers-prod.appspot.com/o/temp%2Fbiz-image%2Fevent_story_detail.jpg?alt=media"}/>
        </div>

      </div>

    </>
  );
};

const enhance = connect(
  state => ( {
    ...state,
  } ),
  {},
);

export default enhance(EventStoryDetailContainer);
